const DB_NAME = import.meta.env.VITE_APP_DB_NAME;
const STORAGE_NAME = 'courses'
const DB_VERSION = import.meta.env.VITE_APP_DB_VER;
const MAX_LIFETIME = 60 * 60 * 1000
let DB

export default {
    async getDB() {
        return new Promise((resolve, reject) => {
            if (DB) {
                return resolve(DB)
            }
            const request = window.indexedDB.open(DB_NAME, DB_VERSION)
            request.onerror = e => {
                console.log('Error opening db', e)
                // eslint-disable-next-line
                reject('Error')
            }
            request.onsuccess = e => {
                DB = e.target.result
                resolve(DB)
            }
            request.onupgradeneeded = e => {
                let db = e.target.result
                db.createObjectStore(STORAGE_NAME)
                db.createObjectStore('breadcrumbs')
                db.createObjectStore('categories')
                db.createObjectStore('nestedCategories')
            }
        })
    },

    async clearCache() {
        let db = await this.getDB()
        for (let name of Object.values(db.objectStoreNames)) {
            let trans = db.transaction(name, "readwrite")
            let store = trans.objectStore(name)
            store.clear()
        }
    },

    async saveNestedCats({categories, key}) {
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction(['nestedCategories'], 'readwrite')
            trans.oncomplete = () => {
                resolve()
            }
            let store = trans.objectStore('nestedCategories')
            categories['db_timestamp'] = new Date().getTime()
            store.put(categories, key)
        })
    },
    async getNestedCategories(key) {
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction(['nestedCategories'], 'readonly')
            const store = trans.objectStore('nestedCategories')
            const categories = store.get(key)
            categories.onsuccess = () => {
                const result = categories?.result
                if (result) {
                    const timestamp = result.db_timestamp
                    const now = new Date().getTime()
                    const diff = now - timestamp
                    if (diff > MAX_LIFETIME)
                        resolve(null)
                }
                resolve(categories.result)
            }
        })
    },

    async saveCategories({categories, page}) {
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction(['categories'], 'readwrite')
            trans.oncomplete = () => {
                resolve()
            }
            let store = trans.objectStore('categories')
            categories['db_timestamp'] = new Date().getTime()
            store.put(categories, page)
        })
    },

    async getCategories(page) {
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction(['categories'], 'readonly')
            const store = trans.objectStore('categories')
            const categories = store.get(page)
            categories.onsuccess = () => {
                const result = categories?.result
                if (result) {
                    const timestamp = result.db_timestamp
                    const now = new Date().getTime()
                    const diff = now - timestamp
                    if (diff > MAX_LIFETIME)
                        resolve(null)
                }
                resolve(categories.result)
            }
        })
    },

    async saveBreadcrumbs({breadcrumbs, key}) {
        if(!key)
            return
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction(['breadcrumbs'], 'readwrite')
            trans.oncomplete = () => {
                resolve()
            }
            let store = trans.objectStore('breadcrumbs')
            store.put(breadcrumbs, key)
        })
    },
    async getBreadcrumbs(key) {
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction(['breadcrumbs'], 'readonly')
            const store = trans.objectStore('breadcrumbs')
            const breadcrumbs = store.get(key)
            breadcrumbs.onsuccess = () => {
                resolve(breadcrumbs.result)
            }
        })
    },


    async deleteCourse(course) {
        const db = await this.getDB()
        return new Promise(resolve => {
            const trans = db.transaction([STORAGE_NAME], 'readwrite')
            trans.oncomplete = () => {
                resolve()
            }
            const store = trans.objectStore(STORAGE_NAME)
            store.delete(course.id)
        })
    },

    async getCourses() {
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction([STORAGE_NAME], 'readonly')
            trans.oncomplete = () => {
                resolve(courses)
            }
            const store = trans.objectStore(STORAGE_NAME)
            const courses = []
            store.openCursor().onsuccess = e => {
                const cursor = e.target.result
                if (cursor) {
                    courses.push(cursor.value)
                    cursor.continue()
                }
            }
        })
    },

    async saveCourse({course,key}) {
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction([STORAGE_NAME], 'readwrite')
            trans.oncomplete = () => {
                resolve()
            }
            let store = trans.objectStore(STORAGE_NAME)
            course.db_timestamp = new Date().getTime()
            store.put(course, key)
        })
    },

    async getCourse(key) {
        if(!key)
            return
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction([STORAGE_NAME], 'readonly')
            const store = trans.objectStore(STORAGE_NAME)
            const course = store.get(key)
            course.onsuccess = () => {
                const result = course?.result
                if (result) {
                    const timestamp = result.db_timestamp
                    const now = new Date().getTime()
                    const diff = now - timestamp
                    if (diff > MAX_LIFETIME)
                        resolve(null)
                }
                resolve(course.result)
            }
        })
    },

    async saveCategory({category, key}) {
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction([STORAGE_NAME], 'readwrite')
            trans.oncomplete = () => {
                resolve()
            }
            let store = trans.objectStore(STORAGE_NAME)
            category.db_timestamp = new Date().getTime()
            store.put(category, key)
        })
    },

    async getCategory(key) {
        if(!key)
            return
        let db = await this.getDB()
        return new Promise(resolve => {
            let trans = db.transaction([STORAGE_NAME], 'readonly')
            const store = trans.objectStore(STORAGE_NAME)
            const category = store.get(+key)
            category.onsuccess = () => {
                const result = category?.result
                if (result) {
                    const timestamp = result.db_timestamp
                    const now = new Date().getTime()
                    const diff = now - timestamp
                    if (diff > MAX_LIFETIME)
                        resolve(null)
                }
                resolve(category.result)
            }
        })
    },

    // async getCategories() {
    //     let db = await this.getDB()
    //     return new Promise(resolve => {
    //         let trans = db.transaction([STORAGE_NAME], 'readonly')
    //         trans.oncomplete = () => {
    //             resolve(categories)
    //         }
    //         const store = trans.objectStore(STORAGE_NAME)
    //         const categories = []
    //         store.openCursor().onsuccess = e => {
    //             const cursor = e.target.result
    //             if (cursor) {
    //                 categories.push(cursor.value)
    //                 cursor.continue()
    //             }
    //         }
    //     })
    // },
}
